var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlusSmall = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#43AF49",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11H18V13H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11L18 11 18 13 6 13z",
    transform: "rotate(90 12 12)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusSmall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus-small.2bc5d4d8.svg";
export { ForwardRef as ReactComponent };